<template>
  <div v-loading="loading" class="personal">
    <!-- form -->
    <el-form :model="form" ref="myForm" hide-required-asterisk>
      <el-form-item
        :label="$t('hzmbChange.label.changeType')"
        prop="changeType"
        :rules="[
          {
            required: true,
            message: $t('hzmbChange.message.notNull'),
          },
        ]"
      >
        <el-select v-model="form.changeType" filterable :disabled="isGHCompany">
          <el-option
            v-for="item in changeTypeOptions"
            :key="item.value"
            :label="item.text"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('hzmbChange.label.validate_type')"
        prop="type"
        :rules="[
          {
            required: true,
            message: $t('hzmbChange.message.notNull'),
          },
        ]"
      >
        <slot name="label">
          <div class="validate_type_tips">
            {{ $t("hzmbChange.message.validate_type_tips") }}
          </div>
        </slot>
        <el-select
          v-model="form.type"
          value-key="code"
          filterable
          @change="changeType"
        >
          <el-option
            v-for="item in [
              { code: 'spNo', label: $t('hzmbChange.label.spNo') },
              {
                code: 'registrationNo',
                label: $t('hzmbChange.label.registrationNo'),
              },
            ]"
            :key="item.code"
            :label="item.label"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="form.type === 'spNo'"
        :label="$t('hzmbChange.label.spNo')"
        prop="spNo"
        :rules="[
          {
            required: true,
            message: $t('hzmbChange.message.notNull'),
          },
          {
            max: 10,
            message: $t('hzmbChange.message.maxLength', [10]),
          },
        ]"
      >
        <el-input
          v-model="form.spNo"
          :placeholder="$t('hzmbChange.message.spNo_plh')"
        ></el-input>
      </el-form-item>
      <el-form-item
        v-if="form.type === 'registrationNo'"
        :label="$t('hzmbChange.label.registrationNo')"
        :rules="[{ required: true, message: $t('hzmbChange.message.notNull') }]"
        prop="registrationNo"
      >
        <el-input
          v-model="form.registrationNo"
          ref="registrationNo"
          @focus="onRegistNoFocus"
        ></el-input>
      </el-form-item>
      <template v-if="isPerson">
        <el-form-item
          :label="$t('hzmbChange.label.identityNo')"
          prop="identNo"
          :rules="[
            {
              required: true,
              message: $t('hzmbChange.message.notNull'),
            },
            {
              max: 20,
              message: $t('hzmbChange.message.maxLength', [20]),
            },
            { validator: identNoCheck, trigger: 'blur' },
          ]"
        >
          <el-input
            v-model="form.identNo"
            maxlength="8"
            :placeholder="$t('hzmbChange.message.identityNo_plh')"
            :disabled="isAccount"
          ></el-input>
        </el-form-item>
      </template>
      <template v-if="isCompany">
        <el-form-item
          :label="$t('hzmbChange.label.macau_company_type')"
          prop="companyType"
          :rules="[
            {
              required: true,
              message: $t('hzmbChange.message.notNull'),
              trigger: 'change',
            },
          ]"
        >
          <el-select
            v-model="form.companyType"
            filterable
            :placeholder="$t('hzmbChange.message.macau_company_type_plh')"
            :disabled="isAccount"
          >
            <el-option
              v-for="item in companyType"
              :key="item.code"
              :label="$t(item.label)"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('hzmbChange.label.companyBrNo')"
          prop="companyNo"
          :rules="[
            {
              required: true,
              message: $t('hzmbChange.message.companyNoCheck'),
            },
            { max: 50, message: $t('hzmbChange.message.maxLength', [50]) },
            { validator: validcodeCompanyNo, trigger: 'blur' },
          ]"
        >
          <slot name="label">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('hzmbChange.message.companyBrNo_tooltips')"
              placement="bottom"
            >
              <i class="el-icon-warning-outline warn-icon"></i>
            </el-tooltip>
          </slot>
          <el-input
            v-model="form.companyNo"
            :placeholder="$t('hzmbChange.message.companyBrNo_plh')"
            :disabled="isAccount"
          ></el-input>
        </el-form-item>
      </template>
      <template v-if="isPhone">
        <el-form-item
          v-if="isGHCompany"
          :label="$t('hzmbChange.label.mobile')"
          prop="mobile"
          :rules="[
            {
              required: true,
              message: $t('hzmbChange.message.notNull'),
            },
            {
              pattern:
                form.mobileAreaCode === '853'
                  ? /^[6]{1}[0-9]{7}$/
                  : /^[0-9]{8}$/,
              message: $t('hzmbChange.message.macauMobile'),
              trigger: 'blur',
            },
          ]"
        >
          <slot name="label">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('hzmbChange.message.mobiltTips')"
              placement="bottom"
            >
              <i class="el-icon-warning-outline warn-icon"></i>
            </el-tooltip>
          </slot>
          <div class="m-mobile_row">
            <el-select
              v-model="form.mobileAreaCode"
              :placeholder="$t('hzmbChange.label.mobileAreaCode')"
            >
              <el-option
                v-for="item in areas"
                :key="item.value"
                :value="item.value"
                :label="item.text"
              ></el-option>
            </el-select>
            <el-input
              v-model.number="form.mobile"
              :placeholder="$t('hzmbChange.message.drvMobile')"
              maxlength="8"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item
          v-else
          :label="$t('hzmbChange.label.macauMobile')"
          prop="mobile"
          :rules="[
            {
              required: true,
              message: $t('hzmbChange.message.notNull'),
            },
            { validator: validcodeMacauMobile },
          ]"
        >
          <el-input
            v-model.number="form.mobile"
            :placeholder="$t('hzmbChange.message.macauMobile_plh')"
            maxlength="8"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('hzmbChange.label.phone_code')"
          prop="captcha"
          :rules="[
            {
              max: 10,
              message: $t('hzmbChange.message.maxLength', [10]),
            },
            ...captchaRules,
          ]"
        >
          <div class="captcha_row" style="width: 100%">
            <el-input
              v-model="form.captcha"
              :placeholder="$t('hzmbChange.message.phone_code_placeholder')"
              @keyup.enter.native="submit"
            ></el-input>
            <el-button
              v-show="show"
              type="primary"
              class="getVerify_btn"
              @click="getCode"
              :disabled="!this.form.mobile"
              :loading="getCodeLoading"
              >{{ $t("hzmbChange.message.get_phone_code") }}</el-button
            >
            <el-button
              v-show="!show"
              type="primary"
              class="getVerify_btn"
              disabled
              >{{ count }}{{ $t("message.second") }}</el-button
            >
          </div>
        </el-form-item>
      </template>
      <el-form-item class="submit_btn">
        <GradientBtn @click="onSubmitClick">
          {{ $t("hzmbChange.action.verify_submit") }}
        </GradientBtn>
      </el-form-item>
    </el-form>
    <!-- 註冊編號和車身編號彈窗 -->
    <RegistrationNoDialog
      v-if="showRegistrationNoDialog"
      @save="registNoSave"
      @close="showRegistrationNoDialog = false"
    ></RegistrationNoDialog>
    <!-- end -->
  </div>
</template>

<script>
import HzmbVehDriApplicationChangeAPI from "@/api/HzmbVehDriApplicationChangeAPI";
import RegistrationNoDialog from "@/components/RegistrationNoDialog";
import GradientBtn from "@/components/GradientBtn.vue";
import { checkServerStatus } from "@/util/util";
import { getChangeTypeOptions } from "@/view/DataRegistration/FormData/HzmbChangeVD/options";
import LoginAPI from "@/api/LoginAPI";
import i18n from "../../../../public/lang/index";
export default {
  components: { RegistrationNoDialog, GradientBtn },
  data() {
    return {
      show: true,
      loading: false,
      form: {
        type: "registrationNo",
        mobileAreaCode: "853",
      },
      getCodeLoading: false,
      timer: null,
      count: "",
      isGetCode: false,
      showRegistrationNoDialog: false,

      captchaRules: [
        {
          required: true,
          message: i18n.t("hzmbChange.message.notNull"),
          trigger: "blur",
        },
      ],
      areas: [
        { value: "853", text: i18n.t("hzmbChange.enum.areas.macau") },
        { value: "852", text: i18n.t("hzmbChange.enum.areas.hongkong") },
      ],
      companyType: [
        {
          code: "CO",
          label: "hzmbChange.enum.companyType.CO",
        },
        {
          code: "EM",
          label: "hzmbChange.enum.companyType.EM",
        },
        {
          code: "SO",
          label: "hzmbChange.enum.companyType.SO",
        },
      ],
    };
  },
  computed: {
    serviceType() {
      return this.$route.params.serviceType;
    },
    isPerson() {
      return this.serviceType === "HZMB_CHANGE_PERSON";
    },
    isCompany() {
      return ["HZMB_CHANGE_COMP", "HZMB_GH_CHANGE_COMP"].includes(
        this.serviceType
      );
    },
    isGHCompany() {
      return this.serviceType === "HZMB_GH_CHANGE_COMP";
    },
    isPhone() {
      return this.$route.params.loginType === "phone";
    },
    isAccount() {
      return this.$route.params.loginType === "account";
    },
    changeTypeOptions: getChangeTypeOptions,
  },
  created() {
    this.get();
  },
  methods: {
    async get() {
      // 跨境客運類型，申請類型指定更換車輛
      if (this.serviceType === "HZMB_GH_CHANGE_COMP") {
        this.form.changeType = "CHANGE_DRIVER";
      }
      if (!this.isAccount) return;
      let accountData = JSON.parse(localStorage.getItem("accountData")) || null;
      let spNo = localStorage.getItem("spNo");

      let { identityNo, mobile, profile } = accountData;
      let { entities } = profile;
      this.form.spNo = spNo;
      if (this.isPerson) {
        this.form.identNo = identityNo;
        this.form.mobile = mobile;
      } else if (this.isCompany) {
        if (entities && entities.length) {
          let { commercialCode } = entities[0];
          this.form.companyType = commercialCode.replace(/[0-9]/gi, "");
          this.form.companyNo = commercialCode.replace(/[^0-9]/gi, "");
          this.form.mobile = mobile;
        }
      }
    },
    async getCode() {
      this.captchaRules[0].required = false;
      try {
        await this.$refs.myForm.validate();
      } catch (error) {
        this.captchaRules[0].required = true;
        return;
      }
      try {
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          const {
            mobile,
            mobileAreaCode,
            spNo,
            registrationNo,
            identificationNo,
            identNo,
          } = this.form;
          const serviceType = this.serviceType;
          this.getCodeLoading = true;
          await LoginAPI.captcha(
            `${mobileAreaCode}${mobile}`,
            serviceType,
            spNo,
            registrationNo,
            identificationNo,
            identNo
          );
          this.show = false;
          this.isGetCode = true;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
        this.captchaRules[0].required = true;
      } catch (error) {
        this.$error(error);
      } finally {
        this.getCodeLoading = false;
      }
    },

    // 修改驗證方式回調
    changeType() {
      delete this.form.spNo;
      delete this.form.registrationNo;
      delete this.form.identificationNo;
    },
    // 驗證車身註冊編號
    onRegistNoFocus() {
      this.$refs["registrationNo"].blur();
      this.showRegistrationNoDialog = true;
    },
    // 註冊編號儲存
    registNoSave(data) {
      let { registrationNo, identificationNo } = data;
      this.$set(this.form, "registrationNo", registrationNo);
      this.$set(this.form, "identificationNo", identificationNo);
      this.showRegistrationNoDialog = false;
    },
    // 驗證澳門手機
    validcodeMacauMobile(rule, value, callback) {
      let reg = /[6]{1}[0-9]{7}/;
      if (value && !reg.test(value)) {
        callback(new Error(this.$t("hzmbChange.message.macauMobile")));
      } else {
        callback();
      }
    },
    // 驗證澳門居民身份證編號
    identNoCheck(rule, value, callback) {
      let reg = /[0-9]{8}/;
      if (value && !reg.test(value)) {
        callback(new Error(this.$t("hzmbChange.message.identityNoCheck")));
      } else {
        callback();
      }
    },
    // 驗證配額公司的商業登記編號
    validcodeCompanyNo(rule, value, callback) {
      let check = true;
      let num = Number(value);
      if (num < 0 || isNaN(num)) {
        check = false;
      }
      if (value && !check) {
        callback(new Error(i18n.t("hzmbChange.message.companyNoCheck")));
      } else {
        callback();
      }
    },
    // 提交按鈕
    async onSubmitClick() {
      if (this.isPhone && !this.isGetCode) {
        this.$message({
          type: "warning",
          message: this.$t("hzmbChange.message.getCode_first"),
        });
        return false;
      }
      try {
        await this.$refs.myForm.validate();
      } catch (error) {
        this.$message({
          type: "error",
          message: this.$t("hzmbChange.message.form_error"),
        });
        return;
      }
      if (
        !this.isGHCompany &&
        ["CHANGE_VEHICLE", "CHANGE_DRIVER"].includes(this.form.changeType)
      ) {
        try {
          await this.$confirm(
            this.$t("hzmbChange.message.submit_application_tips"),
            this.$t("message.confirm_submit_content"),
            {
              type: "warning",
            }
          );
        } catch (error) {
          return;
        }
      }
      this.doCheck();
    },
    // 准入
    async doCheck() {
      this.loading = true;
      const serviceType = this.serviceType;
      try {
        await checkServerStatus(serviceType);
        let obj = {
          ...this.form,
          serviceType,
          identType: "BM",
        };
        const {
          mobile,
          mobileAreaCode,
          captcha,
          changeType,
          spNo,
          identNo,
          registrationNo,
          identificationNo,
          companyType,
          companyNo,
        } = this.form;
        if (this.isCompany) {
          obj.identType = companyType;
          obj.identNo = companyNo;
        }
        if (this.isPhone) {
          let authentication;
          if (this.isPerson) {
            const mobileCheck = await LoginAPI.mobileCheck(
              serviceType,
              `${mobileAreaCode}${mobile}`,
              captcha
            );
            authentication = mobileCheck.authentication;
          }
          if (this.isCompany) {
            const mobileCheck = await LoginAPI.company(
              serviceType,
              spNo,
              registrationNo,
              identificationNo,
              companyType,
              companyNo,
              `${mobileAreaCode}${mobile}`,
              captcha
            );
            authentication = mobileCheck.authentication;
          }
          localStorage.setItem("authentication", authentication);
        }
        const { id: applicationId } =
          await HzmbVehDriApplicationChangeAPI.check(obj);
        localStorage.setItem(
          "verifyForm",
          JSON.stringify({
            changeType,
            spNo,
            registrationNo,
            identificationNo,
            identNo: obj.identNo,
            identType: obj.identType,
          })
        );
        this.$router.replace({
          name: "hzmbChangeVDApplication",
          params: {
            serviceType,
            applicationId,
          },
        });
      } catch (error) {
        this.$error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.m-mobile_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  .el-select {
    width: 200px;
    margin-right: 16px;
  }
}
.captcha_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.getVerify_btn {
  margin-left: 16px;
  min-width: 150px;
}
.submit_btn {
  text-align: center;
  margin: 76px 0;
}
.validate_type_tips {
  clear: both;
  line-height: 24px;
  color: #38959d;
}
</style>
